(() => {
  if (window.nvReviewsReady) return;
  window.nvReviewsReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const updateArrows = (widget) => {
    const track = widget.querySelector('[data-nv-review-track]');
    if (!track) return;
    const atEnd = track.scrollWidth - track.clientWidth - Math.abs(track.scrollLeft) < 3;
    widget.querySelector('[data-nv-reviews-direction="-1"]').disabled = Math.abs(track.scrollLeft) < 3;
    widget.querySelector('[data-nv-reviews-direction="1"]').disabled = atEnd;
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-nv-reviews]').forEach((widget) => {
      if (widget.dataset.nvReviewsInitialized) return;
      widget.dataset.nvReviewsInitialized = 'true';
      const track = widget.querySelector('[data-nv-review-track]');
      if (track) {
        track.addEventListener('scroll', () => updateArrows(widget), { passive: true });
        if (window.ResizeObserver) new ResizeObserver(() => updateArrows(widget)).observe(track);
        updateArrows(widget);
      }
      const dialog = widget.querySelector('[data-nv-review-dialog]');
      if (dialog) {
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('nv-review-dialog-open');
          widget.nvReviewOpener?.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      }
    });
  };
  const filterReviews = (widget) => {
    const list = widget.querySelector('[data-nv-review-list]');
    if (!list) return;
    const query = widget.querySelector('[data-nv-review-search]')?.value.trim().toLocaleLowerCase() || '';
    const sort = widget.querySelector('[data-nv-review-sort]')?.value || 'featured';
    const cards = Array.from(list.querySelectorAll('[data-nv-review-card]'));
    cards.forEach((card, index) => {
      if (!card.dataset.nvReviewOrder) card.dataset.nvReviewOrder = String(index + 1);
      card.hidden = !card.querySelector('.nv-review-card__content').textContent.toLocaleLowerCase().includes(query);
    });
    cards.sort((a, b) => {
      if (sort === 'highest') return Number(b.dataset.nvReviewRating) - Number(a.dataset.nvReviewRating) || Number(a.dataset.nvReviewOrder) - Number(b.dataset.nvReviewOrder);
      if (sort === 'lowest') return Number(a.dataset.nvReviewRating) - Number(b.dataset.nvReviewRating) || Number(a.dataset.nvReviewOrder) - Number(b.dataset.nvReviewOrder);
      return Number(a.dataset.nvReviewOrder) - Number(b.dataset.nvReviewOrder);
    }).forEach((card) => list.append(card));
    const visible = cards.filter((card) => !card.hidden).length;
    widget.querySelector('[data-nv-review-no-results]').hidden = visible > 0;
    widget.querySelector('[data-nv-review-results]').textContent = query ? `${visible} / ${cards.length}` : '';
  };
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-nv-review-search]')) filterReviews(event.target.closest('[data-nv-reviews]'));
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-nv-review-sort]')) filterReviews(event.target.closest('[data-nv-reviews]'));
  });
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-nv-reviews-direction]');
    if (arrow) {
      const track = arrow.closest('[data-nv-reviews]').querySelector('[data-nv-review-track]');
      const first = track.querySelector('[data-nv-review-card]');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      const step = first.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: Number(arrow.dataset.nvReviewsDirection) * step * visibleCards * direction, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    }
    const opener = event.target.closest('[data-nv-open-review], [data-nv-review-jump]');
    if (opener) {
      const widget = opener.closest('[data-nv-reviews]');
      const card = opener.closest('[data-nv-review-card]') || Array.from(widget.querySelectorAll('[data-nv-review-card]')).find((item) => item.dataset.nvReviewCard === opener.dataset.nvReviewJump);
      const dialog = widget.querySelector('[data-nv-review-dialog]');
      const detail = card?.querySelector('[data-nv-review-detail]');
      if (!dialog || !detail || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      initialize(widget.parentElement);
      widget.nvReviewOpener = opener;
      dialog.querySelector('[data-nv-review-dialog-body]').replaceChildren(detail.content.cloneNode(true));
      dialog.showModal();
      document.documentElement.classList.add('nv-review-dialog-open');
      dialog.querySelector('[data-nv-review-close]').focus();
    }
    const close = event.target.closest('[data-nv-review-close]');
    if (close) close.closest('dialog').close();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('nv:variant-change', (event) => initialize(event.target));
})();
